var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form-item',[_c('tms-text-editor',{attrs:{"height":"400","content":_vm.config[_vm.field.key]},on:{"contentUpdated":_vm.updateContent}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }